export class PsQrWorkerToken {

    _qrInfo // string

    constructor(
        qrInfo,
    ) {
        this._qrInfo = qrInfo;
    }

    static fromApiQrWorkerToken(qrWorker) {
        return new this(qrWorker.qr_info);
    }

    qrInfo() {
        return this._qrInfo;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/PsQrWorkerToken.js